"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsageCellContent = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const helpers_1 = require("@veeam/components/lib/Grid/cellRenderers/helpers");
require("@veeam/components/lib/Tooltip/types");
const core_1 = require("../../core");
const helpers_2 = require("./helpers");
const UsageCellContent = ({ total, value }) => {
    const { t } = core_1.useFeatureContext();
    const currentCompactValues = helpers_2.getCompactNumber(value);
    const totalCompactValues = helpers_2.getCompactNumber(total);
    const valueWidth = '65px';
    return (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, align: components_1.STACK_ALIGN.center, gap: components_1.STACK_GAP.s },
        react_1.default.createElement(RoundNumberWithTooltip, Object.assign({}, currentCompactValues, { width: valueWidth, align: components_1.TEXT_ALIGN.right })),
        react_1.default.createElement(components_1.Text, { style: { fontSize: '13px' }, align: components_1.TEXT_ALIGN.center }, t('dashboardWidgets|ratioSeparator')),
        react_1.default.createElement(RoundNumberWithTooltip, Object.assign({}, totalCompactValues, { width: valueWidth, align: components_1.TEXT_ALIGN.left }))));
};
exports.UsageCellContent = UsageCellContent;
const RoundNumberWithTooltip = ({ displayedValue, actualValue, width, align, }) => {
    return components_1.useTooltip({
        delayTimeout: 500,
        renderContent: () => react_1.default.createElement(helpers_1.TooltipText, { size: components_1.TEXT_SIZE.s }, actualValue),
        isActive: !!actualValue,
        render: (_a) => {
            var { ref: r } = _a, tooltipProps = __rest(_a, ["ref"]);
            return (react_1.default.createElement(components_1.Text, Object.assign({}, tooltipProps, { size: components_1.TEXT_SIZE.xl, align: align, style: { width } }), displayedValue));
        },
    });
};
//# sourceMappingURL=UsageCellContent.js.map